<template>
  <v-data-table
    :headers="headers"
    :items="items"
    @click:row="editRow"
    class="elevation-1 border"
    hide-default-footer
    hide-default-header
  >
    <template v-slot:top>
      <v-container class="pa-0" flat>
        <EditableDialog
          :dialog="dialog"
          :editedItem="editedItem"
          :isEditMode="isEditing"
          :fields="fields"
          @closeDialog="closeDialog"
          @saveItem="saveItem"
        />
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDeleteDialog">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="confirmDeleteItem">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </template>
    <template
    v-slot:[`item.${header.value}`]="{ item }"
    v-for="header in headers"
  >
    <div :key="`${item.id}-${header.value}`">
      {{ formatValue(item[header.value]) }}
    </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <td class="pl-2">
        <v-btn small class="mr-2" @click.stop="editRow(item)">Edit</v-btn>
      </td>
      <td v-if="!fixedRows">
        <v-btn small @click.stop="removeRow(item)">Delete</v-btn>
      </td>
    </template>
    <template v-slot:body.append>
      <tr>
        <td colspan="100%">
          <div class="d-flex justify-end">
            <v-btn v-if="!fixedRows" color="primary" dark small  @click="openAddDialog">
              New Row
            </v-btn>
          </div>
        </td>
      </tr>
      <tr :style="{ backgroundColor: PAYMENT_CERTIFICATE_TABLE_COLOR.BLUE, fontWeight: 500 }">
        <td v-for="(header, index) in headers" :key="index" :class="getColumnClass(index)">
          {{ header.total ? formatSum(header.value) : getSummaryText(index) }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { getColumnClass, formatValue, PAYMENT_CERTIFICATE_TABLE_COLOR } from '@/helpers'

export default {
  props: {
    fixedRows: Boolean,
    headers: Array,
    items: Array,
    summaryText: String,
    type: String
  },
  data () {
    return {
      dialog: false,
      dialogDelete: false,
      isEditing: false,
      editedItem: this.getDefaultItem(),
      defaultItem: this.getDefaultItem(),
      getColumnClass,
      formatValue,
      PAYMENT_CERTIFICATE_TABLE_COLOR,
      fields: [
        { label: this.$t('payment.certificate.totalCents'), model: 'totalCents', type: 'number' },
        { label: this.$t('payment.certificate.cumulativeCents'), model: 'cumulativeCents', type: 'number' },
        { label: this.$t('payment.certificate.cumulativePreviousCents'), model: 'cumulativePreviousCents', type: 'number' },
        { label: this.$t('payment.certificate.paymentCents'), model: 'paymentCents', type: 'number' }
      ]
    }
  },
  methods: {
    getDefaultItem () {
      return {
        cumulativeCents: 0,
        cumulativePreviousCents: 0,
        paymentCents: 0,
        totalCents: 0,
        type: this.type
      }
    },
    sumField (field) {
      return this.items.reduce((sum, item) => sum + parseFloat(item[field]), 0)
    },
    editRow (item) {
      this.isEditing = true
      this.editedItem = { ...item }
      this.dialog = true
    },
    addItem (item) {
      this.$emit('addRow', item)
    },
    removeRow (item) {
      this.dialogDelete = true
      this.editedItem = { ...item }
    },
    openAddDialog () {
      this.isEditing = false
      this.editedItem = this.getDefaultItem()
      this.dialog = true
    },
    confirmDeleteItem () {
      this.$emit('removeRow', this.editedItem)
      this.dialogDelete = false
    },
    closeDialog () {
      this.dialog = false
      this.isEditing = false
    },
    closeDeleteDialog () {
      this.dialogDelete = false
    },
    saveItem (item) {
      if (this.isEditing) {
        this.$emit('editRow', item)
      } else {
        this.addItem(item)
      }
      this.closeDialog()
    },
    formatSum (field) {
      const sum = this.sumField(field)
      return isNaN(sum) ? 'N/A' : this.formatValue(sum)
    },
    getSummaryText (index) {
      return index === this.lastTextIndex ? this.summaryText : ''
    }
  },
  computed: {
    lastTextIndex () {
      return this.headers.findIndex(header => header.total) - 1
    }
  }
}
</script>
